export default __webpack_public_path__ + "static/media/yt.a7e0b9a4.png";